// extracted by mini-css-extract-plugin
export default {"main":"styles_main__70mx0","dashboardActions":"styles_dashboardActions__ngl1m","tab":"styles_tab__R2VZ6","active":"styles_active__CwLW4"};